module.exports = __webpack_public_path__ + "img/rx8-75.2d68df0c.png";